import React, { useEffect, useRef } from 'react'
import '../styles/HeroSection.css'
import { T } from './Translation'
import heroImage from '../assets/happyCouple.png'
import CouponModal from './CouponModal'
import { useRegisterNavigation } from '../hooks/useRegisterNavigation'

function HeroSection() {
  const heroRef = useRef(null)
  const { showCouponModal, navigateToRegister, closeCouponModal } = useRegisterNavigation()

  useEffect(() => {
    // This effect handles direct navigation to #hero from URL
    if (window.location.hash === '#hero' && heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <>
      <section id="hero" ref={heroRef} className="hero-section">
        <div className="hero-content">
          <h1>
            <T k="heroTitle" />
          </h1>
          <p>
            <T k="heroSubtitle" />
          </p>
          <button onClick={navigateToRegister}>
            <T k="getStarted" />
          </button>
        </div>
        {/* Using the imported hero image */}
        <div className="hero-image">
          <img src={heroImage} alt="RSVP Hero" />
        </div>
      </section>
      
      <CouponModal 
        isOpen={showCouponModal} 
        onClose={closeCouponModal} 
      />
    </>
  )
}

export default HeroSection
